import React from 'react';
import PropTypes from 'prop-types';

import Card from '../Card/Card';
import ImgNewRole from '../../assets/images/img_add_role.png';
import Text from '../Text/Text';

const AddNewRoleCard = ({ onClick }) => {
  return (
    <Card
      showHeader={false}
      headerBordered={false}
      footerBordered={false}
      styleBodyContainer=""
    >
      <div
        className="flex flex-col items-center justify-center h-[350px] cursor-pointer hover:text-primary"
        role="presentation"
        onClick={() => onClick(undefined)}
      >
        <img src={ImgNewRole} alt="add new role" width={150} height={150} />
        <Text text="Add New Role" bold textStyle="text-[18px]" />
      </div>
    </Card>
  );
};

AddNewRoleCard.propTypes = {
  onClick: PropTypes.func
};

AddNewRoleCard.defaultProps = {
  onClick: () => {}
};

export default AddNewRoleCard;
